import React, { memo } from 'react';
import { Switch, useRouteMatch } from 'react-router';
import { PrivateRoute } from 'common/AuthRoute';
import { BusinessPartnerMyPartnersPage } from 'pages/BusinessPartnerManagement/BusinessPartnerSubpartnersManagement/BusinessPartnerMyPartnersPage';
import NewSubpartnerPage from 'pages/BusinessPartnerManagement/BusinessPartnerSubpartnersManagement/NewSubpartnerPage';

export const BusinessPartnerSubpartnersManagement = memo(() => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <PrivateRoute
        exact
        path={path}
        component={BusinessPartnerMyPartnersPage}
      />
      <PrivateRoute
        exact
        path={`${path}/new-subpartner`}
        component={NewSubpartnerPage}
      />
    </Switch>
  );
});
